<div *ngIf="userFactorSelection" class="multi_fact_con_scr">
  <div class="box">
    <div class="mfa_chall_user-info__avatar">
      <svg
        aria-hidden="true"
        focusable="false"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        width="50"
        height="50"
        class="svg-inline--fa fa-user fa-w-14 fa-3x"
      >
        <path
          fill="currentColor"
          d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
        ></path>
      </svg>
    </div>
    <h1 class="mfa_chall_mfa__title">Where should we send the code?</h1>
    <h2 class="mfa__sub-heading">We’ll send a code for you to verify your account</h2>
    <span
      *ngIf="isErroeInSlect"
      style="letter-spacing: 0.46px; color: #d0021b; font-size: 14px; font-family: 'Sul Sans'"
      role="status"
      aria-live="assertive"
      >{{ selectError }}</span
    >
    <div class="buttons">
      <div *ngFor="let activeFactor of userData?.mfaInfo.activeFactors">
        <button
          class="btn btn-phone"
          (click)="sendCode(activeFactor.factorType)"
          [attr.aria-label]="activeFactor.maskedFactorValue"
        >
          {{ activeFactor.factorType === 0 ? 'SMS ' : activeFactor.factorType === 1 ? 'Voice ' : ''
          }}{{ activeFactor.maskedFactorValue }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="mfa_chall_container mfa_chall_is-fullbleed" *ngIf="userChallengeFactor">
  <div class="mfa_chall_container__col">
    <div class="mfa_chall_container mfa_chall_is-fullbleed mfa_chall_is-adjacent">
      <div class="mfa_chall_container__col">
        <div class="cm__user-banner">
          <div class="mfa_chall_user-info">
            <div class="mfa_chall_user-info__avatar">
              <svg
                aria-hidden="true"
                focusable="false"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                width="50"
                height="50"
                class="svg-inline--fa fa-user fa-w-14 fa-3x"
              >
                <path
                  fill="currentColor"
                  d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                ></path>
              </svg>
            </div>

            <div class="mfa_chall_mfa mfa_chall_mfa--container-verify-code">
              <h1 class="mfa_chall_mfa__title">Enter security code</h1>
              <div class="mfa_chall_mfa__section mfa_chall_text--left">
                <p class="mfa_chall_mfa__desc mfa_chall_mfa__desc--change-security">
                  We sent a security code to:
                  <br />
                  {{ selectedMaskedFactorValue }}
                  <span aria-hidden="true">*</span>
                </p>
              </div>
              <div class="mfa_chall_mfa__section mfa_chall_text--left">
                <form
                  [formGroup]="mfaForm"
                  (ngSubmit)="onSubmit()"
                  class="mfa_chall_form mfa_chall_form--inverse js-form"
                  role="form"
                  aria-label="Security code verification form"
                >
                  <div class="mfa_chall_form__row">
                    <label class="mfa_chall_form__input-label mfa_chall_form__item mfa_chall_form__input-container">
                      <div
                        *ngIf="userData?.mfaInfo.activeFactors.length > 1"
                        class="mfa_chall_form__label-text mfa_chall_form__label--security-code"
                        (click)="changeSecurityMethod()"
                      >
                        <span aria-label="Change security method">Change security method</span>
                      </div>
                      <label style="display: none" for="securityCode" for="securityCode">securityCode</label>
                      <input
                        type="text"
                        placeholder="Security code"
                        class="mfa_chall_form__input js-form-input is-required"
                        inputmode="numeric"
                        autocomplete="one-time-code"
                        [formControlName]="'securityCode'"
                        required
                        aria-required="true"
                        [attr.aria-label]="IsinvalidOtp ? 'Please enter a valid security code' : 'securityCode Input'"
                        aria-describedby="securityCode-error"
                      />
                      <span
                        *ngIf="IsinvalidOtp"
                        style="letter-spacing: 0.46px; color: #d0021b; font-size: 14px; font-family: 'Sul Sans'"
                        role="status"
                        id="securityCode-error"
                        aria-live="assertive"
                        >Please enter a valid security code</span
                      >
                      <span
                        *ngIf="isOtpResent"
                        style="letter-spacing: 0.46px; color: #231f20; font-size: 14px; font-family: 'Sul Sans'"
                        role="status"
                        aria-live="polite"
                        >{{ otpResentMessage }}</span
                      >
                    </label>
                    <div class="mfa_chall_text--right">
                      <button type="button" (click)="resendCode()" class="mfa_chall_link mfa_chall_form--reset-code">
                        <span>Resend code</span>
                      </button>
                    </div>
                    <label
                      class="mfa_chall_form__input-label_checkbox mfa_chall_form__item mfa_chall_form__item--checkbox"
                    >
                      <input
                        type="checkbox"
                        aria-label="Remember me for 7 days"
                        [formControlName]="'remind'"
                        id="dontremindcheck"
                        class="mfa_chall_form__input_checkbox js-form-input"
                      />
                      <div class="mfa_chall_form__label-text-remember">
                        <span class="mfa_chall_form__label-remember-me">Remember me for 7 days</span>
                      </div>
                    </label>
                  </div>
                  <div class="mfa_chall_form__row">
                    <button
                      type="submit"
                      class="mfa_chall_button mfa_chall_button--arrow mfa_chall_button--secondary mfa_chall_button--small js-form-submit"
                    >
                      <span>Verify account</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
